import {match, Pattern} from 'ts-pattern';

import type {DataGridRow} from '@dms/api/core';

import {DATA_GRID_MONEY_VALUE_SCHEMA, readDataGridCell} from './readDataGridCell';

export function readDataGridCellMoney(row: DataGridRow, keys: readonly string[]) {
  const result = DATA_GRID_MONEY_VALUE_SCHEMA.safeParse(readDataGridCell(row, keys));

  return match(result)
    .with({success: false}, () => undefined)
    .with({success: true}, ({data}) => {
      const amount = Number(data.amount);

      return match(amount)
        .with(Pattern.number.finite(), (finiteAmount) => ({
          amount: finiteAmount,
          currency: data.currency,
        }))
        .with(Pattern._, () => undefined)
        .exhaustive();
    })
    .exhaustive();
}
